import PropTypes from 'prop-types';

export default PropTypes.shape({
  id: PropTypes.string,
  createdAt: PropTypes.string,
  updatedAt: PropTypes.string,
  title: PropTypes.string,
  metaTitle: PropTypes.string,
  metaDescription: PropTypes.string,
  slug: PropTypes.string,
  localizationSlug: PropTypes.string,
  clientName: PropTypes.string,
  snippet: PropTypes.shape({
    snippet: PropTypes.string
  }),
  categories: PropTypes.arrayOf(PropTypes.string),
  heroImageData: PropTypes.shape({
    fluid: PropTypes.object
  }),
  atAGlanceRichJSON: PropTypes.object,
  relatedIndustries: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      slug: PropTypes.string
    })
  ),
  videoBlockAtTop: PropTypes.bool,
  relatedServiceLines: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      slug: PropTypes.string,
      serviceSlug: PropTypes.string
    })
  ),
  theChallengeTitle: PropTypes.string,
  theChallengeContentRichJSON: PropTypes.object,
  theChallengeMedia: PropTypes.arrayOf(
    PropTypes.shape({
      fluid: PropTypes.object
    })
  ),
  theSolutionTitle: PropTypes.string,
  theSolutionContentRichJSON: PropTypes.object,
  theSolutionMedia: PropTypes.arrayOf(
    PropTypes.shape({
      fluid: PropTypes.object
    })
  ),
  theResultsTitle: PropTypes.string,
  theResultsContentRichJSON: PropTypes.object,
  theResultsMedia: PropTypes.arrayOf(
    PropTypes.shape({
      fluid: PropTypes.object
    })
  ),
  quoteBlock: PropTypes.object,
    video: PropTypes.shape({
    embedUrl: PropTypes.string,
    title: PropTypes.string
  }),
  metricsBlock: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      percentage: PropTypes.number
    })
  ),
  relatedCaseStudies: PropTypes.arrayOf(
    PropTypes.shape({
      slug: PropTypes.string,
      snippet: PropTypes.string,
      title: PropTypes.string,
      categories: PropTypes.arrayOf(PropTypes.string),
      clientName: PropTypes.string,
      heroImageData: PropTypes.shape({
        fluid: PropTypes.object
      })
    })
  ),
  tools: PropTypes.arrayOf(PropTypes.string),
});
